export default __webpack_public_path__ + "static/media/viewIcon.5284c639.svg";